import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import HOC from '../../components/HOC/HOC';
import { SuccessfullyModal } from '../../components/Modals/Modals';
import addjob from '../../css/style.module.css';

import axios from 'axios';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { getApi, putApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import { formatDateAcc, toDisplayDate } from '../../Repository/helper';
import { BaseUrl, getAuthHeaders } from '../../components/BaseURl/BaseUrl';
import ImageUpload from '../../components/ImageUpload/ImageUpload';
import { formatDate1 } from '../../utils/utils';

const EditStaff = () => {
  // const roleOptions = [
  //     { value: 'TANDOOR CHEF', label: 'TANDOOR CHEF' },
  //     { value: 'ASSISTANT CHEF', label: 'ASSISTANT CHEF' },
  //     { value: 'KITCHEN MANAGER', label: 'KITCHEN MANAGER' },
  //     { value: 'COOKING ASSISTANT', label: 'COOKING ASSISTANT' },
  //     { value: 'GRILL MASTER', label: 'GRILL MASTER' },
  //     { value: 'TANDOOR ATTENDANT', label: 'TANDOOR ATTENDANT' },
  //     { value: 'LINE COOK', label: 'LINE COOK' },
  //     { value: 'FOOD PREPARATION ASSISTANT', label: 'FOOD PREPARATION ASSISTANT' },
  //     { value: 'DISHWASHER', label: 'DISHWASHER' },
  //     { value: 'SERVER', label: 'SERVER' },
  //     { value: 'KITCHEN HELPER', label: 'KITCHEN HELPER' },
  //     { value: 'FOOD SAFETY COORDINATOR', label: 'FOOD SAFETY COORDINATOR' },
  //     { value: 'TANDOOR MAESTRO', label: 'TANDOOR MAESTRO' },
  //     { value: 'CHEF DE CUISINE', label: 'CHEF DE CUISINE' },
  //     { value: 'SOUCHEF', label: 'SOUCHEF' },
  //     { value: 'KITCHEN ASSISTANT', label: 'KITCHEN ASSISTANT' },
  // ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingjob, setLoadingJob] = useState(false);
  const [jobsdata, setJobsData] = useState([]);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    dateOfBirth: '',
    gender: '',
    businessStreet1: '',
    businessStreet2: '',
    businessTown: '',
    businessLandMark: '',
    businessCity: '',
    businessCountry: '',
    businessPostCode: '',
    subcategoryId: [],
    travelingDistance: 0,
    fromHourRange: 0,
    toHourRange: 0,
    bankName: '',
    bankAccountNumber: '',
    ifscCode: '',
    upiId: '',
    // role: [],
    description: '',
    gstNo: '',
    status: '',
  });
  const [files, setFiles] = useState({
    addressProof: null,
    aadharCardFront: null,
    aadharCardBack: null,
    panCardLicensePassport: null,
    policeVerification: null,
    image: null,
  });

  const [imagePreviews, setImagePreviews] = useState({
    addressProof: '',
    aadharCardFront: '',
    aadharCardBack: '',
    panCardLicensePassport: '',
    policeVerification: '',
    image: '',
  });

  const uploadImage = async (url, file) => {
    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await axios.post(`${BaseUrl}${url}`, formData, getAuthHeaders());

      if (response?.data?.data) {
        console.log('Image uploaded successfully:', response.data.data);
        return response.data.data; // Return the uploaded image URL
      } else {
        console.error('Unexpected response format:', response);
        return null;
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      return null;
    }
  };

  const fetchStaffData = useCallback(async () => {
    await getApi(endPoints.getStaffbyid(id), {
      setResponse: (response) => {
        const data = response?.data || {};
         
        setFormData({
          firstName: data.firstName || '',
          lastName: data.lastName || '',
          phone: data.phone || '',
          email: data.email || '',
          dateOfBirth: formatDateAcc(data.dateOfBirth),
          gender: data.gender || '',
          businessStreet1: data.businessStreet1 || '',
          businessStreet2: data.businessStreet2 || '',
          businessTown: data.businessTown || '',
          businessLandMark: data.businessLandMark || '',
          businessCity: data.businessCity || '',
          businessCountry: data.businessCountry || '',
          businessPostCode: data.businessPostCode || '',
          subcategoryId: (data.subcategoryId || []).map((item) => item._id),
          travelingDistance: data.travelingDistance || 0,
          fromHourRange: data.fromHourRange || 0,
          toHourRange: data.toHourRange || 0,
          bankName: data.bankName || '',
          bankAccountNumber: data.bankAccountNumber || '',
          ifscCode: data.ifscCode || '',
          upiId: data.upiId || '',
          status: data.status || '',
          // role: data.role || '',
          description: data.description || '',
          gstNo: data.gstNo || '',
        });
        setImagePreviews({
          addressProof: data.addressProof || '',
          aadharCardFront: data.aadharCardFront || '',
          aadharCardBack: data.aadharCardBack || '',
          panCardLicensePassport: data.panCardLicensePassport || '',
          policeVerification: data.policeVerification || '',
          image: data.image || '',
        });
        setFiles({
          addressProof: data.addressProof || '',
          aadharCardFront: data.aadharCardFront || '',
          aadharCardBack: data.aadharCardBack || '',
          panCardLicensePassport: data.panCardLicensePassport || '',
          image: data.image || '',
          policeVerification: data.policeVerification || '',
        });
      },
      setLoading,
      errorMsg: 'Failed to fetch data!',
    });
  }, [id]);

  const handleSubmit = async () => {
    setLoading(true);

    if (!files || typeof files !== 'object') {
      console.error('Invalid files object. Expected an object, got:', files);
      setLoading(false);
      return;
    }
    const uploadedImages = {};
    const uploadPromises = Object.entries(files).map(async ([key, file]) => {
      if (file) {
        try {
          const url = await uploadImage('api/v1/user/uploadImage', file);
          if (url) {
            uploadedImages[key] = url;
          }
        } catch (error) {
          console.error(`Failed to upload ${key}:`, error);
        }
      }
    });

    await Promise.all(uploadPromises);

    const payload = {
      ...formData,
      ...uploadedImages,
      dateOfBirth: toDisplayDate(formData.dateOfBirth),
    };
    try {
      await putApi(endPoints.updatedStaffById(id), payload, {
        setLoading,
        successMsg: 'Staff Updated successfully!',
        errorMsg: 'Failed to update staff!',
      });

      setShow(true);

      setTimeout(() => {
        setShow(false);
        navigate('/staff-management/registered');
      }, 2000);
    } catch (error) {
      console.error('Update failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    await getApi(endPoints.getallsubcategory, {
      setResponse: setJobsData,
      setLoading: setLoadingJob,
      errorMsg: 'Failed to fetch jobs!',
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchStaffData();
  }, [fetchStaffData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFiles((prev) => ({ ...prev, [name]: files[0] }));

    const filePreview = URL.createObjectURL(files[0]);
    setImagePreviews((prev) => ({ ...prev, [name]: filePreview }));
  };

  const handleClearImage = (name) => {
    setImagePreviews((prev) => ({ ...prev, [name]: '' }));
    setFiles((prev) => ({ ...prev, [name]: null }));
  };

  const MultiSelectCheckbox = ({
    options,
    selectedValues,
    onSelect,
    onRemove,
    placeholder,
    searchable = false,
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [tempSelections, setTempSelections] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const wrapperRef = useRef(null);

    useEffect(() => {
      if (isOpen) {
        setTempSelections(selectedValues || []);
      }
    }, [isOpen]);

    const filteredOptions = searchable
      ? options?.filter((option) =>
          (option.name || '').toLowerCase().includes(searchTerm.toLowerCase())
        )
      : options;

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleTempSelect = (value) => {
      setTempSelections((prev) =>
        prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
      );
    };

    const applySelections = () => {
      const toAdd = tempSelections?.filter((v) => !(selectedValues || []).includes(v));
      const toRemove = (selectedValues || []).filter((v) => !tempSelections.includes(v));

      toAdd.forEach((value) => onSelect(value));
      toRemove.forEach((value) => onRemove(value));

      setIsOpen(false);
    };

    const cancelSelections = () => {
      setTempSelections(selectedValues || []);
      setIsOpen(false);
    };

    const toggleSelectAll = () => {
      if (tempSelections.length === filteredOptions.length) {
        setTempSelections([]);
      } else {
        setTempSelections(filteredOptions.map((opt) => opt._id));
      }
    };

    return (
      <div className={addjob.multiSelectWrapper} ref={wrapperRef}>
        <div className={addjob.selectInput} onClick={() => setIsOpen(!isOpen)}>
          {placeholder}
          <span className={addjob.arrowIcon}>
            {isOpen ? <IoIosArrowUp size={20} /> : <IoIosArrowDown size={20} />}
          </span>
        </div>

        {isOpen && (
          <div className={addjob.dropdown}>
            {searchable && (
              <div className={addjob.searchBox}>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            )}

            <div className={addjob.selectAllContainer}>
              <button type="button" onClick={toggleSelectAll} className={addjob.selectAllButton}>
                {tempSelections.length === filteredOptions.length ? 'Deselect All' : 'Select All'}
              </button>
            </div>

            <div className={addjob.optionsContainer}>
              {filteredOptions.map((option) => (
                <h6 key={option._id} className={addjob.optionItem}>
                  <input
                    type="checkbox"
                    checked={tempSelections.includes(option._id)}
                    onChange={() => handleTempSelect(option._id)}
                  />
                  {option.name}
                </h6>
              ))}
            </div>

            <div className={addjob.dropdownFooter}>
              <button type="button" className={addjob.cancelButton} onClick={cancelSelections}>
                Cancel
              </button>
              <button type="button" className={addjob.applyButton} onClick={applySelections}>
                Apply ({tempSelections.length})
              </button>
            </div>
          </div>
        )}

        <div className={addjob.selectedTags}>
          {(selectedValues || []).map((value) => {
            const option = options?.find((opt) => opt?._id === value);
            return (
              <div key={value} className={addjob.tag}>
                <span>{option?.name}</span>
                <button type="button" className={addjob.removeBtn} onClick={() => onRemove(value)}>
                  ×
                </button>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <SuccessfullyModal
        show={show}
        handleClose={() => setShow(false)}
        text={'Successfully Updated'}
      />
      <div className={addjob.jobmanagementCotainer}>
        <div className={addjob.jobtoppart}>
          <div className={addjob.pagetitle}>
            <h6>Edit Staff Profile</h6>
          </div>
        </div>

        <div className={addjob.addjobcontainer}>
          <div className={addjob.addjobsubcontainer}>
            <div className={addjob.addjobtopic}>
              <h6>Edit Staff Details</h6>
            </div>
            <div className={addjob.addcontactdetails}>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">First Name</label>
                <input
                  type="text"
                  name="firstName"
                  placeholder="Enter first name"
                  value={formData.firstName}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Last Name</label>
                <input
                  type="text"
                  placeholder="Enter last name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Email</label>
                <input
                  type="email"
                  placeholder="Enter email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Number</label>
                <input
                  type="text"
                  placeholder="Enter number"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              {/* <div className={addjob.addjobinputs}>
                                <label htmlFor="">Role</label>
                                <MultiSelectCheckbox
                                    options={roleOptions}
                                    selectedValues={formData.role}
                                    onSelect={(value) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            role: [...(prev.role || []), value]
                                        }))
                                    }
                                    onRemove={(value) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            role: prev.role.filter(v => v !== value)
                                        }))
                                    }
                                    placeholder="Select roles..."
                                />
                            </div> */}
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Status</label>
                <select value={formData.status} name="status" onChange={handleChange}>
                  <option value="">Select</option>
                  <option value="Active">Active</option>
                  <option value="Pending">Pending</option>
                  <option value="Block">Block</option>
                </select>
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Date Of Birth</label>
                <input
                  type="date"
                  value={formatDate1(formData.dateOfBirth)}
                  name="dateOfBirth"
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Gender</label>
                <select value={formData.gender} name="gender" onChange={handleChange}>
                  <option value="">Select</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Business Street1</label>
                <input
                  type="text"
                  placeholder="Enter the business street1"
                  name="businessStreet1"
                  value={formData.businessStreet1}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Business Street2</label>
                <input
                  type="text"
                  placeholder="Enter the business street2"
                  name="businessStreet2"
                  value={formData.businessStreet2}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Business Town</label>
                <input
                  type="text"
                  placeholder="Enter the business town"
                  name="businessTown"
                  value={formData.businessTown}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Business LandMark</label>
                <input
                  type="text"
                  placeholder="Enter the business landmark"
                  name="businessLandMark"
                  value={formData.businessLandMark}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Business City</label>
                <input
                  type="text"
                  placeholder="Enter the business city"
                  name="businessCity"
                  value={formData.businessCity}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Business Country</label>
                <input
                  type="text"
                  placeholder="Enter the business country"
                  name="businessCountry"
                  value={formData.businessCountry}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Business PostCode</label>
                <input
                  type="text"
                  placeholder="Enter the business postcode"
                  name="businessPostCode"
                  value={formData.businessPostCode}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Job Role</label>
                <MultiSelectCheckbox
                  options={jobsdata?.data}
                  selectedValues={formData.subcategoryId}
                  onSelect={(value) =>
                    setFormData((prev) => ({
                      ...prev,
                      subcategoryId: [...(prev.subcategoryId || []), value],
                    }))
                  }
                  onRemove={(value) =>
                    setFormData((prev) => ({
                      ...prev,
                      subcategoryId: prev.subcategoryId.filter((v) => v !== value),
                    }))
                  }
                  placeholder="Select subcategory..."
                  searchable
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Traveling Distance</label>
                <input
                  type="number"
                  placeholder="Enter the traveling distance"
                  name="travelingDistance"
                  value={formData.travelingDistance}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">From Hour Range</label>
                <input
                  type="number"
                  placeholder="Enter the from hour range"
                  name="fromHourRange"
                  value={formData.fromHourRange}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">To Hours Range</label>
                <input
                  type="number"
                  placeholder="Enter the to hour Range"
                  name="toHourRange"
                  value={formData.toHourRange}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Bank Name</label>
                <input
                  type="text"
                  placeholder="Enter the bank name"
                  name="bankName"
                  value={formData.bankName}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Bank Account Number</label>
                <input
                  type="text"
                  placeholder="Enter the bank account number"
                  name="bankAccountNumber"
                  value={formData.bankAccountNumber}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">IFSC Code</label>
                <input
                  type="text"
                  placeholder="Enter the IFSC Code"
                  name="ifscCode"
                  value={formData.ifscCode}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">GST No</label>
                <input
                  type="text"
                  placeholder="Enter the gstNo"
                  name="gstNo"
                  value={formData.gstNo}
                  onChange={handleChange}
                />
              </div>
              <div className={addjob.addjobinputs}>
                <label htmlFor="">Upi Id </label>
                <input
                  type="text"
                  placeholder="Enter the upiId"
                  name="upiId"
                  value={formData.upiId}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className={addjob.addjobinputs}>
              <label htmlFor="">Description</label>
              <textarea
                placeholder="description"
                value={formData.description}
                name="description"
                onChange={handleChange}
              />
            </div>
            <div className={addjob.addjobtopic}>
              <h6>Documents</h6>
            </div>
            <div className={addjob.addcontactdetails}>
              <ImageUpload
                label="Profile Image*"
                name="image"
                onChange={handleFileChange}
                imagePreview={imagePreviews.image}
                onClear={() => handleClearImage('image')}
              />
              {/* <ImageUpload
                                label="Address Proof Image*"
                                name="addressProof"
                                onChange={handleFileChange}
                                imagePreview={imagePreviews.addressProof}
                                onClear={() => handleClearImage('addressProof')}
                            />
                            <ImageUpload
                                label="Aadhar Card Front Image*"
                                name="aadharCardFront"
                                onChange={handleFileChange}
                                imagePreview={imagePreviews.aadharCardFront}
                                onClear={() => handleClearImage('aadharCardFront')}
                            />

                            <ImageUpload
                                label="Aadhar Card Back Image*"
                                name="aadharCardBack"
                                onChange={handleFileChange}
                                imagePreview={imagePreviews.aadharCardBack}
                                onClear={() => handleClearImage('aadharCardBack')}
                            />
                            <ImageUpload
                                label="Pan Card/DL/Passport Image*"
                                name="panCardLicensePassport"
                                onChange={handleFileChange}
                                imagePreview={imagePreviews.panCardLicensePassport}
                                onClear={() => handleClearImage('panCardLicensePassport')}
                            />
                            <ImageUpload
                                label="Police Verification Image*"
                                name="policeVerification"
                                onChange={handleFileChange}
                                imagePreview={imagePreviews.policeVerification}
                                onClear={() => handleClearImage('policeVerification')}
                            /> */}
            </div>
          </div>
          <div className={addjob.addjobbutton}>
            <div className={addjob.rightbuttons}>
              <button onClick={() => navigate(-1)}>Cancel</button>
            </div>
            <div className={addjob.rightbuttons}>
              <button onClick={handleSubmit} style={{ background: '#F05423' }} disabled={loading}>
                {loading ? 'Updating...' : 'Update'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HOC(EditStaff);
